import React from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSignOutAlt } from "react-icons/fa";

export const Header = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated"); // Clear authentication state
    navigate("/"); // Redirect to Login
  };
  return (
    <div
      className="row align-items-center"
      style={{ background: "#003E32", height: "100px" }}
    >
      <div className="col-md-3">
        <img
          src="./Logo.png"
          alt=""
          style={{ marginTop: "27px", marginLeft: "30px" }}
        />
      </div>
      <div className="col-md-9 d-flex justify-content-end">
        <button
          onClick={handleLogout}
          className="btn btn-primary mt-4 text-white px-4 py-2 rounded-md hover:bg-red-600"
        >
          Logout
          <FaSignOutAlt style={{ marginLeft: "10px" }} />
        </button>
      </div>
    </div>
  );
};
